import { render, staticRenderFns } from "./ProductionSortiesProd.vue?vue&type=template&id=eb28052e&scoped=true&"
import script from "./ProductionSortiesProd.vue?vue&type=script&lang=js&"
export * from "./ProductionSortiesProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb28052e",
  null
  
)

export default component.exports